const getFileExt = (name) => {
  return name.substring(name.lastIndexOf('.')+1, name.length)
};

export { 
  getFileExt
}